import { Container, useSlotRecipe } from '@chakra-ui/react';
import { DraggablePanelFooterProps } from '@components/ui/draggable/DraggablePanel';
import { forwardRef } from 'react';

export const Footer = forwardRef<HTMLDivElement, DraggablePanelFooterProps>(({ children, ...rest }, ref) => {
  const { footer } = useSlotRecipe({ key: 'draggablePanel' })();
  return (
    <Container ref={ref} {...footer} {...rest}>
      {children}
    </Container>
  );
});
